import { isPlatformBrowser } from '@angular/common';
import { ElementRef, Injectable, PLATFORM_ID, inject } from '@angular/core';
/**
 * Used to provide a way to invoke element methods.
 * Based on https://github.com/angular/angular/issues/13818#issuecomment-372276031
 * and the source code of the old Renderer V1.
 */
@Injectable({
  providedIn: 'root'
})
export class AgrRendererService {
  private platformId = inject<{}>(PLATFORM_ID);

  invokeElementMethod(eleRef: ElementRef, method: string, args: any[] = []): void {
    if (isPlatformBrowser(this.platformId)) {
      const element = eleRef.nativeElement;
      element[method].apply(element, args);
    }
  }
}
